import React, { memo, useEffect, useState } from 'react';
import { connect } from 'react-redux';

import connectOptions, { mergeProps } from '../utils/connectOptions';
import { removeApiError } from '../actions/applicationErrors';
import { usePopupContext } from '../contexts/PopupContext';

/** Popup names that should be closed in case of an error. */
const closablePopups = ['EditEmailTemplateSendGridPopup'];

const getShouldClosablePopup = popup => closablePopups.includes(popup);

/**
 * Wrapper that displays api's errors.
 */
const ApiErrorDisplayWrapper = ({ errors, removeApiError, children }) => {
  const { openPopup: openPopupContext, hasPopup, onClosePopup, getPopupName } = usePopupContext();
  const [planned, setPlanned] = useState(false);

  const openPopup = () => {
    if (errors.size === 0) return;

    const error = errors.get(0);

    openPopupContext('ApiErrorPopup', { error });
    onClosePopup(() => {
      removeApiError({ error });
    });
  };

  useEffect(() => {
    if (planned) return;

    const shouldClosablePopup = getShouldClosablePopup(getPopupName());

    if (hasPopup() && !shouldClosablePopup) {
      setPlanned(true);

      onClosePopup(() => {
        setImmediate(() => {
          openPopup();
          setPlanned(false);
        });
      });

      return;
    }

    openPopup();
  });

  return <div className="full-height">{children}</div>;
};

/**
 * Map application's state to appState property.
 *
 * @param state {Object} Application's state.
 */
function mapStateToProps(state) {
  return {
    errors: state.applicationErrors.get('api'),
  };
}

export { ApiErrorDisplayWrapper };
export default connect(mapStateToProps, { removeApiError }, mergeProps, connectOptions)(memo(ApiErrorDisplayWrapper));
